export enum CommonError {
    OrderNotFound = 1,
}

export const getCommonError = (error: any): CommonError | undefined => {
    if (error.additionValue) {
        return error.additionValue.errorCode
    }

    return undefined
}

export const isExceedLogin = (error: any) => {
    return (
        error.status === 401 &&
        (error.message === 'login.error.exceed_active_terminals_per_user' ||
            error.message ===
                'login.error.exceed_active_terminals_per_user_in_same_terminal')
    )
}

const LICENSE_INVALID_ERROR_MESSAGE = 'license.invalid_or_expired'

export const isLicenseError = (error: any) => {
    return (
        (error.status === 401 || error.response?.status === 401) &&
        (error.response?.data === LICENSE_INVALID_ERROR_MESSAGE ||
            error.message === LICENSE_INVALID_ERROR_MESSAGE)
    )
}
